import { URL, platform } from "../constants/constant";
import axios from "axios";
import { _axios } from "../plugins/axios";

export async function userLogin(payload) {
	return (await _axios.post(`${URL.dev_url}v1/userLogin`, payload))?.data;
}

export async function fetchUserBenefits(payload, usertoken) {
	return (
		await _axios.post(`${URL.dev_url}v1/userBenefits`, payload, {
			headers: { usertoken },
		})
	)?.data;
}

export async function AddBeneficiary(payload, accesstoken) {
	return (
		await axios.post(`${URL.mb_wapi}Labs/v2/AddBenefeciary`, payload, {
			headers: { accesstoken },
		})
	)?.data;
}

export async function ApplyLabsCoupon(payload, accesstoken) {
	return (
		await axios.post(`${URL.mb_wapi}Labs/ApplyCoupon`, payload, {
			headers: { accesstoken },
		})
	)?.data;
}

export async function fileUpload(file) {
	const payload = new FormData();

	payload.append("FileName", file.name?.split(".")?.[0]);

	payload.append("File", file);

	payload.append("FileExtension", file.name?.split(".")?.[1]);

	return (
		await axios.post(`https://oms.medibuddy.in/oms/uploadFile`, payload, {
			headers: { "Content-Type": "multipart/form-data" },
		})
	)?.data;
}

export async function paymentMethod(payload, usertoken) {
	return (
		await _axios.post(`${URL.dev_url}payment`, payload, {
			headers: { usertoken, platform: platform },
		})
	)?.data;
}
